<table matSort mat-table [dataSource]="dataSource" class="w-full">
    <ng-container matColumnDef="fund">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'label_fund' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.fund }}</td>
    </ng-container>
    <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef>{{ 'label_age' | translate }}</th>
        <td mat-cell *matCellDef="let item">{{ item.age }}</td>
    </ng-container>
    <ng-container matColumnDef="acquisitionType">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'label_pension_benefit_acquisition_type' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
            {{ 'label_pension_benefit_acquisition_type_' + item.acquisitionType | translate }}
        </td>
    </ng-container>
    <ng-container matColumnDef="acquisitionCoefficient">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'label_coefficient' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
            {{ item.acquisitionCoefficient }}
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
</table>
<div class="flex items-center justify-end mt-4">
    <button class="ml-4" mat-flat-button type="submit" (click)="updateAcquisitionCoefficients()" color="primary">
        {{ 'label_update_data' | translate }}
    </button>
</div>
